
    export const environment = {
        production: true,
        endpoint: () => 'https://api.estudei.com.br'
    };
